import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { IchServiceModule } from '..';
import { SavedIchFiltersComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    IchServiceModule
  ],
  declarations: [SavedIchFiltersComponent],
  exports: [SavedIchFiltersComponent],

})
export class SavedIchFiltersComponentModule { }
